import * as v from 'valibot';
const attributeTypedArrayValueSchema = v.variant('type', [
    v.object({ type: v.literal('NoData'), value: v.array(v.null()) }),
    v.object({ type: v.literal('Data8'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data16'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data24'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data32'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data40'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data48'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data56'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Data64'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bool'), value: v.array(v.boolean()) }),
    v.object({ type: v.literal('Bitmap8'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap16'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap24'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap32'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap40'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap48'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap56'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Bitmap64'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt8'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt16'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt24'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt32'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt40'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt48'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt56'), value: v.array(v.number()) }),
    v.object({ type: v.literal('UInt64'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int8'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int16'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int24'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int32'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int40'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int48'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int56'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Int64'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Enum8'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Enum16'), value: v.array(v.number()) }),
    v.object({ type: v.literal('FloatSemi'), value: v.array(v.string()) }),
    v.object({ type: v.literal('FloatSingle'), value: v.array(v.string()) }),
    v.object({ type: v.literal('FloatDouble'), value: v.array(v.string()) }),
    v.object({ type: v.literal('OctetStr'), value: v.array(v.array(v.number())) }),
    v.object({ type: v.literal('CharStr'), value: v.array(v.string()) }),
    v.object({ type: v.literal('LongOctetStr'), value: v.array(v.array(v.number())) }),
    v.object({ type: v.literal('LongCharStr'), value: v.array(v.string()) }),
    v.object({ type: v.literal('Array'), value: v.array(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('Struct'), value: v.array(v.array(v.lazy(() => attributeTypedStructValueSchema))) }),
    v.object({ type: v.literal('Set'), value: v.array(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('Bag'), value: v.array(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('TimeOfDay'), value: v.array(v.string()) }),
    v.object({ type: v.literal('Date'), value: v.array(v.string()) }),
    v.object({ type: v.literal('UTCTime'), value: v.array(v.number()) }), // seconds since 1st of January, 2000 UTC
    v.object({ type: v.literal('ClusterID'), value: v.array(v.number()) }),
    v.object({ type: v.literal('AttributeID'), value: v.array(v.number()) }),
    v.object({ type: v.literal('BACnetOID'), value: v.array(v.string()) }),
    v.object({ type: v.literal('IEEEAddr'), value: v.array(v.string()) }),
    v.object({ type: v.literal('Security128'), value: v.array(v.array(v.number())) }),
    v.object({ type: v.literal('Unknown'), value: v.array(v.null()) }),
]);
const attributeTypedStructValueSchema = v.variant('type', [
    v.object({ type: v.literal('NoData'), value: v.null() }),
    v.object({ type: v.literal('Data8'), value: v.number() }),
    v.object({ type: v.literal('Data16'), value: v.number() }),
    v.object({ type: v.literal('Data24'), value: v.number() }),
    v.object({ type: v.literal('Data32'), value: v.number() }),
    v.object({ type: v.literal('Data40'), value: v.number() }),
    v.object({ type: v.literal('Data48'), value: v.number() }),
    v.object({ type: v.literal('Data56'), value: v.number() }),
    v.object({ type: v.literal('Data64'), value: v.number() }),
    v.object({ type: v.literal('Bool'), value: v.boolean() }),
    v.object({ type: v.literal('Bitmap8'), value: v.number() }),
    v.object({ type: v.literal('Bitmap16'), value: v.number() }),
    v.object({ type: v.literal('Bitmap24'), value: v.number() }),
    v.object({ type: v.literal('Bitmap32'), value: v.number() }),
    v.object({ type: v.literal('Bitmap40'), value: v.number() }),
    v.object({ type: v.literal('Bitmap48'), value: v.number() }),
    v.object({ type: v.literal('Bitmap56'), value: v.number() }),
    v.object({ type: v.literal('Bitmap64'), value: v.number() }),
    v.object({ type: v.literal('UInt8'), value: v.number() }),
    v.object({ type: v.literal('UInt16'), value: v.number() }),
    v.object({ type: v.literal('UInt24'), value: v.number() }),
    v.object({ type: v.literal('UInt32'), value: v.number() }),
    v.object({ type: v.literal('UInt40'), value: v.number() }),
    v.object({ type: v.literal('UInt48'), value: v.number() }),
    v.object({ type: v.literal('UInt56'), value: v.number() }),
    v.object({ type: v.literal('UInt64'), value: v.number() }),
    v.object({ type: v.literal('Int8'), value: v.number() }),
    v.object({ type: v.literal('Int16'), value: v.number() }),
    v.object({ type: v.literal('Int24'), value: v.number() }),
    v.object({ type: v.literal('Int32'), value: v.number() }),
    v.object({ type: v.literal('Int40'), value: v.number() }),
    v.object({ type: v.literal('Int48'), value: v.number() }),
    v.object({ type: v.literal('Int56'), value: v.number() }),
    v.object({ type: v.literal('Int64'), value: v.number() }),
    v.object({ type: v.literal('Enum8'), value: v.number() }),
    v.object({ type: v.literal('Enum16'), value: v.number() }),
    v.object({ type: v.literal('FloatSemi'), value: v.string() }),
    v.object({ type: v.literal('FloatSingle'), value: v.string() }),
    v.object({ type: v.literal('FloatDouble'), value: v.string() }),
    v.object({ type: v.literal('OctetStr'), value: v.array(v.number()) }),
    v.object({ type: v.literal('CharStr'), value: v.string() }),
    v.object({ type: v.literal('LongOctetStr'), value: v.array(v.number()) }),
    v.object({ type: v.literal('LongCharStr'), value: v.string() }),
    v.object({ type: v.literal('Array'), value: v.lazy(() => attributeTypedArrayValueSchema) }),
    v.object({ type: v.literal('Struct'), value: v.array(v.lazy(() => attributeTypedStructValueSchema)) }),
    v.object({ type: v.literal('Set'), value: v.lazy(() => attributeTypedArrayValueSchema) }),
    v.object({ type: v.literal('Bag'), value: v.lazy(() => attributeTypedArrayValueSchema) }),
    v.object({ type: v.literal('TimeOfDay'), value: v.string() }),
    v.object({ type: v.literal('Date'), value: v.string() }),
    v.object({ type: v.literal('UTCTime'), value: v.number() }), // seconds since 1st of January, 2000 UTC
    v.object({ type: v.literal('ClusterID'), value: v.number() }),
    v.object({ type: v.literal('AttributeID'), value: v.number() }),
    v.object({ type: v.literal('BACnetOID'), value: v.string() }),
    v.object({ type: v.literal('IEEEAddr'), value: v.string() }),
    v.object({ type: v.literal('Security128'), value: v.array(v.number()) }),
    v.object({ type: v.literal('Unknown'), value: v.null() }),
]);
export const attributeTypedValueSchema = v.variant('type', [
    v.object({ type: v.literal('NoData'), value: v.optional(v.null()) }),
    v.object({ type: v.literal('Data8'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data16'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data24'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data32'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data40'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data48'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data56'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Data64'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bool'), value: v.optional(v.boolean()) }),
    v.object({ type: v.literal('Bitmap8'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap16'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap24'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap32'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap40'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap48'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap56'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Bitmap64'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt8'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt16'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt24'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt32'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt40'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt48'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt56'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('UInt64'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int8'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int16'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int24'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int32'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int40'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int48'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int56'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Int64'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Enum8'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('Enum16'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('FloatSemi'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('FloatSingle'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('FloatDouble'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('OctetStr'), value: v.optional(v.array(v.number())) }),
    v.object({ type: v.literal('CharStr'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('LongOctetStr'), value: v.optional(v.array(v.number())) }),
    v.object({ type: v.literal('LongCharStr'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('Array'), value: v.optional(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('Struct'), value: v.optional(v.array(v.lazy(() => attributeTypedStructValueSchema))) }),
    v.object({ type: v.literal('Set'), value: v.optional(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('Bag'), value: v.optional(v.lazy(() => attributeTypedArrayValueSchema)) }),
    v.object({ type: v.literal('TimeOfDay'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('Date'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('UTCTime'), value: v.optional(v.number()) }), // seconds since 1st of January, 2000 UTC
    v.object({ type: v.literal('ClusterID'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('AttributeID'), value: v.optional(v.number()) }),
    v.object({ type: v.literal('BACnetOID'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('IEEEAddr'), value: v.optional(v.string()) }),
    v.object({ type: v.literal('Security128'), value: v.optional(v.array(v.number())) }),
    v.object({ type: v.literal('Unknown'), value: v.optional(v.null()) }),
]);
function renderArrayValuePrim(vs) {
    return '[' + vs.map((x) => renderAttributeValue(x)).join(', ') + ']';
}
function renderArrayValue(v) {
    // there is limit in typescript of 24 union types in a descriminator, so we split this in smaller
    // bunches so the typescript compiler is happy
    //
    // https://github.com/microsoft/TypeScript/issues/40803
    switch (v.type) {
        case 'Data8':
        case 'Data16':
        case 'Data24':
        case 'Data32':
        case 'Data40':
        case 'Data48':
        case 'Data56':
        case 'Data64':
        case 'Bitmap8':
        case 'Bitmap16':
        case 'Bitmap24':
        case 'Bitmap32':
        case 'Bitmap40':
        case 'Bitmap48':
        case 'Bitmap56':
        case 'Bitmap64':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'UInt8':
        case 'UInt16':
        case 'UInt24':
        case 'UInt32':
        case 'UInt40':
        case 'UInt48':
        case 'UInt56':
        case 'UInt64':
        case 'Int8':
        case 'Int16':
        case 'Int24':
        case 'Int32':
        case 'Int40':
        case 'Int48':
        case 'Int56':
        case 'Int64':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Bool':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Enum8':
        case 'Enum16':
        case 'UTCTime':
        case 'ClusterID':
        case 'AttributeID':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'FloatSemi':
        case 'FloatSingle':
        case 'FloatDouble':
        case 'CharStr':
        case 'LongCharStr':
        case 'TimeOfDay':
        case 'Date':
        case 'BACnetOID':
        case 'IEEEAddr':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'OctetStr':
        case 'LongOctetStr':
        case 'Security128':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Array':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Set':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Bag':
            return renderArrayValuePrim(v.value.map((x) => ({ type: v.type, value: x })));
        case 'Struct':
            return '[' + v.value.map((x) => renderAttributeValue({ type: 'Struct', value: x })).join(', ') + ']';
        case 'NoData':
            return 'NoData';
        case 'Unknown':
            return 'Unknown';
    }
}
export function renderAttributeValue(v) {
    if (v.value === undefined) {
        return 'undefined';
    }
    else {
        switch (v.type) {
            case 'NoData':
                return '';
            case 'Unknown':
                return '';
            case 'Bool':
                return v.value ? '\u2705' : '\u274C';
            case 'Array':
            case 'Bag':
            case 'Set':
                return renderArrayValue(v.value);
            case 'Struct':
                return '{' + v.value.map((x) => renderAttributeValue(x)).join(', ') + '}';
            default:
                return v.value.toString();
        }
    }
}
export const testValues1 = { type: 'Array', value: { type: 'CharStr', value: ['a', 'b'] } };
export const testValues2 = { type: 'Array', value: { type: 'Array', value: [{ type: 'CharStr', value: ['a', 'b'] }, { type: 'UInt8', value: [2, 3] }] } };
export const testValues3 = { type: 'Struct', value: [{ type: 'CharStr', value: 'abc' }, { type: 'UInt8', value: 42 }] };
export const testValues4 = { type: 'Struct', value: [{ type: 'Struct', value: [{ type: 'CharStr', value: 'abcd' }, { type: 'UInt8', value: 2 }] }] };
